/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from "react";
import Axios from 'axios';
import { Helmet } from "react-helmet";
import { Col, Row } from "reactstrap";
import Summary from "../Registration/subComponents/Summary";
import { AssociationUrl } from "../../config/properties";

export const getInvitations = async () => {
  try {
    const response = await Axios.get(`${AssociationUrl}/getInvitations`);
    console.log("Invitation:", response);
    if (response.data) {
      for (let i = 0; i < response.data.length; i++) {
        const item = response.data[i];
        item.admins = [{
          name: item.pointOfContact,
          email: item.email,
          phoneNumber: item.phoneNumber
        }];
        item.cageCode = item.data;
      }
    }
    // Imitate getOrganizationsByStatus:
    return { organizationByStatus: { organizations: response.data } };
  } catch (error) {
    console.log("Get Invitation Error:", error)
    return {};
  }
}
const LIMIT = '?limit=500&offset=0';
const MAIL = '&mailinator=team91444.testinator.com';
const DUMP1 = '&ignoreZero=true&useCatalog=2&compareIcon=true';
// const DUMP3 = '&useFilter=true&ignoreZero=true&compareIcon=true';
const VIEW = '&getCage=true&getPoc=true';
const CREATE = '&doCreateOrgs=true&forceUpdate=true';

export const getNffsOrgs = async (name = undefined, execute = false) => {
  const FIND = name ? `${DUMP1}&findField=name&findValue=${name}` : DUMP1;
  const EXECUTE = execute ? `${VIEW}${CREATE}${MAIL}` : '';
  try {
    console.log("Getting Nffs Orgs")
    const response = await Axios.get(`${AssociationUrl}/dumpNffs${LIMIT}${FIND}${EXECUTE}`);
    console.log("Nffs Orgs:", response);
    if (response.data) {
      if (!name) {
        for (let i = 0; i < response.data.Companies.length; i++) {
          const item = response.data.Companies[i];
          const assoc = item.associationValidations;
          let qPoc = '';
          if (!item.iconStatus && !item.inviteDate && !item.pointOfContact) {
            qPoc = assoc[0].pocUniqueId ? '?' : 'n/a';
          }
          if (!assoc[0].status) {
            assoc[0].status = 'unknown';
          }
          item.admins = [{
            name: item.pointOfContact ? item.pointOfContact : qPoc,
            email: item.email,
            phoneNumber: item.phoneNumber
          }];
        }
        // Imitate getOrganizationsByStatus:
        return { organizationByStatus: { organizations: response.data.Companies, capabilities: response.data.Catalog } };
      }
      return response.data.Companies;
    }
  } catch (error) {
    console.log("Get Nffs Orgs Error:", error)
  }
  return {};
}

export const getFiaOrgs = async (name = undefined, execute = false) => {
  const FIND = name ? `${DUMP1}&findField=name&findValue=${name}` : DUMP1;
  const EXECUTE = execute ? `${VIEW}${CREATE}${MAIL}` : '';
  try {
    console.log("Getting Fia Orgs")
    const response = await Axios.get(`${AssociationUrl}/dumpFia${LIMIT}${FIND}${EXECUTE}`);
    console.log("Fia Orgs:", response);
    if (response.data) {
      if (!name) {
        for (let i = 0; i < response.data.Companies.length; i++) {
          const item = response.data.Companies[i];
          item.admins = [{
            name: item.pointOfContact,
            email: item.email,
            phoneNumber: item.phoneNumber
          }];
        }
        // Imitate getOrganizationsByStatus:
        return { organizationByStatus: { organizations: response.data.Companies, capabilities: response.data.Catalog } };
      }
      return response.data.Companies;
    }
  } catch (error) {
    console.log("Get Fia Orgs Error:", error)
  }
  return {};
}

export const getInvitation = async (orgId) => {
  try {
    const response = await Axios.get(`${AssociationUrl}/getInvitation?orgId=${orgId}`);
    console.log("Invitation:", response);
    return response.data;
  } catch (error) {
    console.log("Get Invitation Error:", error)
    return {};
  }
}

export const sendInvitation = async (item) => {
  if (!item.email) {
    alert("Company has no email address");
    return {};
  }
  if (!item.pointOfContact && item.associationValidations && !item.associationValidations[0].pocUniqueId) {
    const emailName = item.email.replace(/@.*/, '').replace(/__.*/, '');
    if (emailName.includes('.')) {
      if (!confirm("Company has no Point of Contact.  If you proceed, the text before the @ in the email address will be used as the Point of Contact")) {
        return {};
      }
    } else {
      alert("Company has no Point of Contact and its email address doesn't have an obvious first and last name");
      return {};
    }
  }
  try {
    let uniqueId;
    let response;
    if (item.iconStatus === 'Approved' || item.iconStatus === 'approved') {
      response = await Axios.get(`${AssociationUrl}/updateRemote?orgId=${item.id}`);
      console.log("updateRemote:", response);
    } else {
      if (item.associationValidations[0].name === 'NFFS') {
        uniqueId = item.associationValidations[0].uniqueId;
      }
      if (uniqueId) {
        const FIND = `${DUMP1}&findUniqueId=${uniqueId}`;
        const EXECUTE = `${VIEW}${CREATE}`;
        response = await Axios.get(`${AssociationUrl}/dumpNffs${LIMIT}${FIND}${EXECUTE}`);
        console.log("dumpNffs:", response)
      } else {
        const xItem = { ...item, admins: undefined, iconStatus: undefined, entityName: undefined }
        if (item.iconStatus && item.iconStatus !== 'Invited') {
          xItem.iconStatus = item.iconStatus.toLowerCase();
        }
        console.log("sendInvitation:", response);
        response = await Axios.put(`${AssociationUrl}/sendInvitation`, xItem);
      }
    }
    response.data.admins = [{
      name: response.data.pointOfContact,
      email: response.data.email,
      phoneNumber: response.data.phoneNumber
    }];
    return response.data;
  } catch (error) {
    alert("Send Invitation Error");
    return {};
  }
}

const Invitation = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const orgId = urlParams.get('orgId');
  const [org, setOrg] = useState({});
  const [finalSubmit, setFinalSubmit] = useState('');


  useEffect(() => {
    const fetchOrg = async () => {
      const data = await getInvitation(orgId);
      setOrg(data);
    }
    fetchOrg();
  }, []);

  // const handleChange = () => {

  // }

  const handleSubmit = async () => {
    try {
      await Axios.get(`${AssociationUrl}/acceptInvitation?orgId=${orgId}`);
      setFinalSubmit("success");
    } catch (error) {
      setFinalSubmit("failure");
      console.log("Accept Invitation Failure")
    }
  }

  const handleCancel = () => {
    window.history.back();
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - Registration Page</title>
      </Helmet>
      <div className="nf-registration">
        <Row>
          <Col xs={1} />
          <Col>
            <h1 className="nf-registration__header">
              Verify Information and Submit
            </h1>
            <p className="nf-registration__subheader">
              Your request will be viewed and approved by the appropriate admins
            </p>
          </Col>
          {/* <!-- ADD USER BUTTON --> */}
        </Row>
        <Row className="mt-4">
          <Col xs={1} />
          <Col>
            <Summary
              name={org.pointOfContact}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              currentFlow="industry"
              cage={org.data}
              email={org.email}
              organization={org}
              phone={org.phoneNumber}
              orgType={org.organizationType}
              finalSubmit={finalSubmit}
            />
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Invitation;


// WEBPACK FOOTER //
// ./src/pages/Invitation/Invitation.jsx